export enum SliderTypes {
  PersonalDetails = 'Personal Details',
  TaxDetails = 'Tax Details',
  BankDetails = 'Bank Details',
  Password = 'Password',
}

export enum NotificationPreferences {
  MarketingEmails = 'emailAlerts',
}
